/**
 * Australian states and territories. Australia-only scope (per CLAUDE.md) — this
 * is the canonical jurisdiction list, not a "country" abstraction. Used by the
 * course-search state filter, which matches a master course's provider
 * (master_providers.primary_state).
 */

export const AU_STATES = ['NSW', 'VIC', 'QLD', 'WA', 'SA', 'TAS', 'ACT', 'NT'] as const;

export type AuState = (typeof AU_STATES)[number];

export const AU_STATE_LABELS: Record<AuState, string> = {
  NSW: 'New South Wales',
  VIC: 'Victoria',
  QLD: 'Queensland',
  WA: 'Western Australia',
  SA: 'South Australia',
  TAS: 'Tasmania',
  ACT: 'Australian Capital Territory',
  NT: 'Northern Territory',
};
